import type { NylasMessage, NylasThread } from '@equaliq/api-model';

const DEF_JAM_GRANT_ID = 'def-jam-demo-grant-001';
const DEF_JAM_CONNECTION_EMAIL = 'tim.pithouse@defjam.com';

function ts(iso: string): number {
  return Math.floor(new Date(iso).getTime() / 1000);
}

export const defJamThreads: NylasThread[] = [
  {
    threadMetadataId: 'dj-thread-meta-1',
    externalThreadId: 'dj-ext-thread-1',
    provider: 'google',
    connectionEmail: DEF_JAM_CONNECTION_EMAIL,
    lastMessageAt: '2026-03-19T10:30:00Z',
    messageCount: 3,
    summary: 'Coco Jones Recording Deal - Final Review',
    priority: 5,
    labels: ['inbox', 'important'],
    ragKeywords: ['coco jones', 'recording deal', 'territory', 'royalties'],
    analyzed: true,
    analyzedAt: '2026-03-19T10:40:00Z',
    createdAt: '2026-03-18T16:30:00Z',
    updatedAt: '2026-03-19T10:30:00Z',
  },
  {
    threadMetadataId: 'dj-thread-meta-2',
    externalThreadId: 'dj-ext-thread-2',
    provider: 'google',
    connectionEmail: DEF_JAM_CONNECTION_EMAIL,
    lastMessageAt: '2026-03-19T09:15:00Z',
    messageCount: 3,
    summary: 'Bieber Amendment - Signing Status',
    priority: 4,
    labels: ['inbox'],
    ragKeywords: ['bieber', 'amendment', 'signing', 'advance'],
    analyzed: true,
    analyzedAt: '2026-03-19T09:20:00Z',
    createdAt: '2026-03-18T11:00:00Z',
    updatedAt: '2026-03-19T09:15:00Z',
  },
  {
    threadMetadataId: 'dj-thread-meta-3',
    externalThreadId: 'dj-ext-thread-3',
    provider: 'google',
    connectionEmail: DEF_JAM_CONNECTION_EMAIL,
    lastMessageAt: '2026-03-18T16:30:00Z',
    messageCount: 2,
    summary: 'Nasty C JV Update - Structure',
    priority: 3,
    labels: ['inbox'],
    ragKeywords: ['nasty c', 'jv', 'territories', 'capitalization'],
    analyzed: true,
    analyzedAt: '2026-03-18T16:45:00Z',
    createdAt: '2026-03-18T16:30:00Z',
    updatedAt: '2026-03-18T17:00:00Z',
  },
  {
    threadMetadataId: 'dj-thread-meta-4',
    externalThreadId: 'dj-ext-thread-4',
    provider: 'google',
    connectionEmail: DEF_JAM_CONNECTION_EMAIL,
    lastMessageAt: '2026-03-16T14:00:00Z',
    messageCount: 3,
    summary: 'Nike Sync Terms - 2 Chainz',
    priority: 3,
    labels: ['inbox'],
    ragKeywords: ['nike', 'sync', '2 chainz', 'campaign'],
    analyzed: true,
    analyzedAt: '2026-03-16T14:15:00Z',
    createdAt: '2026-03-16T09:00:00Z',
    updatedAt: '2026-03-16T14:00:00Z',
  },
];

export const defJamThreadMessages: NylasMessage[] = [
  {
    id: 'dj-thread-msg-1',
    threadId: 'dj-ext-thread-1',
    subject: 'Coco Jones Recording Deal - Final Review',
    snippet: 'A&R has approved the creative terms for the Coco Jones recording deal.',
    body: '<p>A&amp;R has approved the creative terms for the Coco Jones recording deal. The album commitment, touring split, and merch provisions all look good from our side.</p>',
    from: [{ name: 'Nicole Billings', email: 'nicole.billings@defjam.com' }],
    to: [{ name: 'Tim Pithouse', email: DEF_JAM_CONNECTION_EMAIL }],
    date: ts('2026-03-18T14:00:00Z'),
    unread: false,
    folders: ['INBOX'],
  },
  {
    id: 'dj-thread-msg-2',
    threadId: 'dj-ext-thread-1',
    subject: 'Re: Coco Jones Recording Deal - Final Review',
    snippet: 'Can we confirm the worldwide territory scope includes the Nasty C JV territories?',
    body: '<p>Can we confirm the worldwide territory scope includes the Nasty C JV territories?</p>',
    from: [{ name: 'Tim Pithouse', email: DEF_JAM_CONNECTION_EMAIL }],
    to: [{ name: 'Kecia Tatum', email: 'kecia.tatum@defjam.com' }],
    date: ts('2026-03-18T17:15:00Z'),
    unread: false,
    folders: ['INBOX', 'SENT'],
  },
  {
    id: 'dj-thread-msg-3',
    threadId: 'dj-ext-thread-1',
    subject: 'Re: Coco Jones Recording Deal - Final Review',
    snippet: 'The recording deal terms are ready for your final review and sign-off.',
    body: '<p>The recording deal terms are ready for your final review and sign-off. Please review Sections 4, 8, 10, and 12 before we send it back to management.</p>',
    from: [{ name: 'Kecia Tatum', email: 'kecia.tatum@defjam.com' }],
    to: [{ name: 'Tim Pithouse', email: DEF_JAM_CONNECTION_EMAIL }],
    date: ts('2026-03-19T10:30:00Z'),
    unread: true,
    starred: true,
    folders: ['INBOX', 'IMPORTANT'],
  },
  {
    id: 'dj-thread-msg-4',
    threadId: 'dj-ext-thread-2',
    subject: 'Bieber Amendment - Signing Status',
    snippet: 'The Bieber Album 7 amendment has completed legal review.',
    body: '<p>The Bieber Album 7 amendment has completed legal review. The $12M advance structure and updated royalty terms are finalized.</p>',
    from: [{ name: 'Kecia Tatum', email: 'kecia.tatum@defjam.com' }],
    to: [{ name: 'Tim Pithouse', email: DEF_JAM_CONNECTION_EMAIL }],
    date: ts('2026-03-18T11:00:00Z'),
    unread: false,
    folders: ['INBOX'],
  },
  {
    id: 'dj-thread-msg-5',
    threadId: 'dj-ext-thread-2',
    subject: 'Re: Bieber Amendment - Signing Status',
    snippet: 'Are we good to move to execution?',
    body: '<p>Are we good to move to execution? Jeff, do you need a final walkthrough?</p>',
    from: [{ name: 'Tim Pithouse', email: DEF_JAM_CONNECTION_EMAIL }],
    to: [{ name: 'Jeff Harleston', email: 'jeff.harleston@defjam.com' }],
    date: ts('2026-03-18T14:30:00Z'),
    unread: false,
    folders: ['INBOX', 'SENT'],
  },
  {
    id: 'dj-thread-msg-6',
    threadId: 'dj-ext-thread-2',
    subject: 'Re: Bieber Amendment - Signing Status',
    snippet: 'Legal has approved. Moving to execution.',
    body: '<p>Legal has approved. Moving to execution. I am comfortable with the final terms and we should get this signed before end of month.</p>',
    from: [{ name: 'Jeff Harleston', email: 'jeff.harleston@defjam.com' }],
    to: [{ name: 'Tim Pithouse', email: DEF_JAM_CONNECTION_EMAIL }],
    date: ts('2026-03-19T09:15:00Z'),
    unread: true,
    folders: ['INBOX'],
  },
  {
    id: 'dj-thread-msg-7',
    threadId: 'dj-ext-thread-3',
    subject: 'Nasty C JV Update - Structure',
    snippet: 'Got feedback from Nasty C’s team on the sublabel structure.',
    body: '<p>Got feedback from Nasty C&apos;s team on the sublabel structure. They&apos;re aligned on the creative director role and the $3M initial capitalization.</p>',
    from: [{ name: 'Marcus Reynolds', email: 'marcus.reynolds@defjam.com' }],
    to: [{ name: 'Tim Pithouse', email: DEF_JAM_CONNECTION_EMAIL }],
    date: ts('2026-03-18T16:30:00Z'),
    unread: true,
    folders: ['INBOX'],
  },
  {
    id: 'dj-thread-msg-8',
    threadId: 'dj-ext-thread-3',
    subject: 'Re: Nasty C JV Update - Structure',
    snippet: 'North Africa expansion is interesting. Let’s discuss next call.',
    body: '<p>North Africa expansion is interesting. Let&apos;s discuss that on the next call. The phase-one funding structure still works.</p>',
    from: [{ name: 'Jeff Harleston', email: 'jeff.harleston@defjam.com' }],
    to: [{ name: 'Tim Pithouse', email: DEF_JAM_CONNECTION_EMAIL }],
    date: ts('2026-03-18T17:00:00Z'),
    unread: false,
    folders: ['INBOX'],
  },
  {
    id: 'dj-thread-msg-9',
    threadId: 'dj-ext-thread-4',
    subject: 'Nike Sync Terms - 2 Chainz',
    snippet: 'Nike brand team sent over initial sync terms for the 2 Chainz Air Max campaign.',
    body: '<p>Nike brand team sent over initial sync terms for the 2 Chainz Air Max campaign. The proposal is $750K for 12-month usage across TV, digital, and social.</p>',
    from: [{ name: 'Sasha Robinson', email: 'sasha.robinson@defjam.com' }],
    to: [{ name: 'Tim Pithouse', email: DEF_JAM_CONNECTION_EMAIL }],
    date: ts('2026-03-16T09:00:00Z'),
    unread: false,
    folders: ['INBOX'],
  },
  {
    id: 'dj-thread-msg-10',
    threadId: 'dj-ext-thread-4',
    subject: 'Re: Nike Sync Terms - 2 Chainz',
    snippet: 'Let’s negotiate the exclusivity window down to six months.',
    body: '<p>The fee looks fair for 12 months, but let&apos;s negotiate the exclusivity window down to six months and keep broader footwear carve-outs.</p>',
    from: [{ name: 'Tim Pithouse', email: DEF_JAM_CONNECTION_EMAIL }],
    to: [{ name: 'Sasha Robinson', email: 'sasha.robinson@defjam.com' }],
    date: ts('2026-03-16T11:00:00Z'),
    unread: false,
    folders: ['INBOX', 'SENT'],
  },
  {
    id: 'dj-thread-msg-11',
    threadId: 'dj-ext-thread-4',
    subject: 'Re: Nike Sync Terms - 2 Chainz',
    snippet: 'I’ll push back on the exclusivity window and propose the carve-outs.',
    body: '<p>I&apos;ll push back on the exclusivity window and propose the carve-outs. I should have a revised paper from Nike by tomorrow.</p>',
    from: [{ name: 'Sasha Robinson', email: 'sasha.robinson@defjam.com' }],
    to: [{ name: 'Tim Pithouse', email: DEF_JAM_CONNECTION_EMAIL }],
    date: ts('2026-03-16T14:00:00Z'),
    unread: false,
    folders: ['INBOX'],
  },
];
